import { Link } from 'react-router-dom';

export const Footer = () => {
  const navigationItems = [
    {
      title: 'Home',
      to: '#',
      description: '',
      items: [
        {
          title: 'Features',
          to: '#features',
        },
        {
          title: 'Services',
          to: '#services',
        },
        {
          title: 'Account Confirmation',
          to: '/account-confirmation',
        },
      ],
    },
    {
      title: 'Socials',
      // description: 'Managing a small business today is already tough.',
      items: [
        {
          title: 'Instagram',
          to: 'https://www.instagram.com/eclipsefitnesslv/?igsh=MXFkbXV6bGNobDc2dw%3D%3D&utm_source=qr',
        },
      ],
    },
    {
      title: 'Contact Info',
      email: 'Jason.Warren@eclipsefitnesslv.com',
      phone: '(702) 308-9450',
    },
  ];

  return (
    <footer className="w-full py-20 lg:py-40">
      <hr className="mx-auto w-11/12" />
      <div className="container mx-auto pt-20">
        <div className="items-cente-0 grid lg:grid-cols-2">
          <div className="flex flex-col items-start gap-8">
            <div className="flex flex-col gap-2">
              <h2 className="font-regular max-w-xl text-left text-3xl tracking-tighter md:text-5xl">
                Eclipse Fitness LV ™
              </h2>
              <p className="max-w-lg text-left text-lg leading-relaxed tracking-tight text-primary"></p>
            </div>
            <div className="flex flex-row gap-20">
              <div className="flex max-w-lg flex-col text-left text-sm font-semibold leading-relaxed tracking-tight text-primary">
                <p>3460 E Sunset Rd, Suite A</p>
                <p>Las Vegas</p>
                <p>NV 89120</p>
              </div>
              <div className="flex max-w-lg flex-col text-left text-sm leading-relaxed tracking-tight text-primary">
                <Link to="/terms-and-conditions" target="_blank">
                  Terms And Conditions
                </Link>
                <Link to="/privacy-policy" target="_blank">
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>
          <div className="grid items-start gap-10 lg:grid-cols-3">
            {/*146 Title */}
            {navigationItems.map((item) => (
              <div
                key={item.title}
                className="flex flex-col items-start gap-1 text-base"
              >
                <div className="flex flex-col gap-2 ">
                  {/*Links for Title */}
                  {item.to ? (
                    <Link
                      to={item.to}
                      className="flex items-center justify-between font-semibold"
                    >
                      <span className="text-xl">{item.title}</span>
                    </Link>
                  ) : (
                    <p className="text-xl font-semibold">{item.title}</p>
                  )}
                  {item.email && (
                    <p className="text-wrap text-sm">{item.email}</p>
                  )}
                  {item.phone && <p className="text-sm">{item.phone}</p>}
                  {item.items &&
                    item.items.map((subItem) => (
                      <Link
                        key={subItem.title}
                        to={subItem.to}
                        target={item.title === 'Follow US' ? '_blank' : '_self'}
                        className="flex items-center justify-between"
                      >
                        <span className="text-primary">{subItem.title}</span>
                      </Link>
                    ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};
